<template>
  <md-avatar class="md-avatar-icon md-small icon-inline" v-if="algoValue">
    <md-icon>error_outline</md-icon>
    <md-tooltip md-direction="right"
      >Algorithm value: {{ algoValue }}</md-tooltip
    >
  </md-avatar>
</template>

<style scoped></style>

<script>
export default {
  props: ["algoValue"]
};
</script>
